import { Component } from '@theme/component';

/**
 * @typedef {Object} CollectionIntroRefs
 * @property {HTMLElement} introText
 * @property {HTMLButtonElement} introToggle
 */

/** @extends {Component<CollectionIntroRefs>} */
class CollectionIntro extends Component {
  requiredRefs = ['introText', 'introToggle'];

  connectedCallback() {
    super.connectedCallback();
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.refs.introText);
    this.addEventListener('focusin', this.#onFocusIn);
    document.fonts?.ready.then(() => this.update());
    this.update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.observer?.disconnect();
    this.removeEventListener('focusin', this.#onFocusIn);
  }

  toggle = () => {
    const { introToggle } = this.refs;
    const willExpand = this.dataset.expanded !== 'true';

    this.dataset.expanded = String(willExpand);
    introToggle.textContent = willExpand ? this.dataset.lessLabel : this.dataset.moreLabel;
    if (!willExpand) this.update();
  };

  /** @param {FocusEvent} event */
  #onFocusIn = (event) => {
    const { introText, introToggle } = this.refs;
    if (this.dataset.expanded === 'true' || !introToggle || introToggle.hidden) return;
    if (event.target instanceof Node && introText?.contains(event.target)) this.toggle();
  };

  update() {
    const { introText, introToggle } = this.refs;
    if (!introText || !introToggle || this.dataset.expanded === 'true') return;
    introToggle.hidden = introText.scrollHeight <= introText.clientHeight + 1;
    this.dataset.clamped = String(!introToggle.hidden);
  }
}

if (!customElements.get('ca-collection-intro')) {
  customElements.define('ca-collection-intro', CollectionIntro);
}
